module.exports = __webpack_public_path__ + "img/information.18de4905.png";